module.exports = __webpack_public_path__ + "img/img-2.376bef3e.png";